import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import wretch from 'wretch';
import { slugify } from '../../../helpers/utils';
import UpTriangle from '../../atoms/icons/up-triangle';
import DownTriangle from '../../atoms/icons/down-triangle';
import ArrowRightSmall from '../../atoms/icons/right-arrow';

import './stock-search.m.css';

class StockSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stockValues: {},
      isLoading: true
    };
  }

  componentDidMount() {
    this.props.stockId && this.getStockValues(this.props.stockId);
  }

  getStockValues = stockId => {
    wretch(`https://www.ndtvprofit.com/next/feapi/stock/${stockId}/basic-details`)
      .get()
      .json(result => {
        this.setState({ isLoading: false, stockValues: get(result, 'data', {}) });
      })
      .catch(error => error);
  };

  render() {
    const currentIndex = this.props.currentIndex;
    const totalCount = this.props.totalCount;
    const stockData = get(this.props, ['stock'], {});
    const stockNameSlug = slugify(stockData.COMPNAME);
    const isLoading = get(this.state, ['isLoading'], true);
    const bseCurrentPrice = get(this.state, ['stockValues', 'bse', 'currentPrice'], 0);
    const bseAbsValue = get(this.state, ['stockValues', 'bse', 'priceChange'], 0);
    const bseChangePercentage = get(this.state, ['stockValues', 'bse', 'changePercentage'], 0);
    const nseCurrentPrice = get(this.state, ['stockValues', 'nse', 'currentPrice'], 0);
    const nseAbsValue = get(this.state, ['stockValues', 'nse', 'priceChange'], 0);
    const nseChangePercentage = get(this.state, ['stockValues', 'nse', 'changePercentage'], 0);
    const bseAddClass = bseAbsValue >= 0 ? 'successColor' : 'dangerousColor';
    const nseAddClass = nseAbsValue >= 0 ? 'successColor' : 'dangerousColor';
    return (
      <div styleName="stock-search" data-stock-id={stockData.STOCKID}>
        <div styleName="stock-search-card">
          <div styleName="stock-search-widget">
            <div styleName="stock-header-wrapper" className="stock-header">
              <div>
                <h2 styleName="stock-header-title">{stockData.COMPNAME}</h2>
                <span styleName="stock-industry-text">{stockData.INDUSTRY}</span>
              </div>
              <div styleName="count-wrapper">
                {currentIndex + 1}
                {'/'}
                {totalCount}
              </div>
            </div>
            <div styleName="stock-exchange-wrapper ">
              {isLoading || bseCurrentPrice > 0 ? (
                <div styleName="stock-exchange-item-wrapper">
                  <div>
                    <h2 styleName="exchange-header-title">BSE</h2>
                    <div styleName="exchange-header-abbr">Bombay Stock Exchange</div>
                  </div>
                  {!isLoading ? (
                    <div>
                      <h2 styleName="exchange-header-title exchange-current-price">
                        {typeof bseCurrentPrice === 'number' ? bseCurrentPrice.toFixed(2) : 0}
                      </h2>
                      <div styleName={`exchange-header-abbr ${bseAddClass}`}>
                        {bseAddClass === 'successColor' ? (
                          <UpTriangle styleName="stock-ticker" fontSize="9px" />
                        ) : (
                          <DownTriangle styleName="stock-ticker" fontSize="9px" />
                        )}{' '}
                        {typeof bseChangePercentage === 'number'
                          ? bseChangePercentage.toFixed(2)
                          : 0}
                        %
                      </div>
                    </div>
                  ) : (
                    <div styleName="floatBarsG">
                      <div styleName="floatBarsG1 floatBarsG_1" />
                      <div styleName="floatBarsG1 floatBarsG_2" />
                      <div styleName="floatBarsG1 floatBarsG_3" />
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <h2 styleName="exchange-header-title">BSE</h2>
                  <div styleName="exchange-header-abbr">Data/Stock not listed on BSE</div>
                </div>
              )}
              {isLoading || nseCurrentPrice > 0 ? (
                <div styleName="stock-exchange-item-wrapper">
                  <div>
                    <h2 styleName="exchange-header-title">NSE</h2>
                    <div styleName="exchange-header-abbr">National Stock Exchange</div>
                  </div>
                  {!isLoading ? (
                    <div>
                      <h2 styleName="exchange-header-title exchange-current-price">
                        {typeof nseCurrentPrice === 'number' ? nseCurrentPrice.toFixed(2) : 0}
                      </h2>
                      <div styleName={`exchange-header-abbr ${nseAddClass}`}>
                        {nseAddClass === 'successColor' ? (
                          <UpTriangle styleName="stock-ticker" fontSize="9px" />
                        ) : (
                          <DownTriangle styleName="stock-ticker" fontSize="9px" />
                        )}{' '}
                        {typeof nseChangePercentage === 'number'
                          ? nseChangePercentage.toFixed(2)
                          : 0}
                        %
                      </div>
                    </div>
                  ) : (
                    <div styleName="floatBarsG">
                      <div styleName="floatBarsG1 floatBarsG_1" />
                      <div styleName="floatBarsG1 floatBarsG_2" />
                      <div styleName="floatBarsG1 floatBarsG_3" />
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <h2 styleName="exchange-header-title">NSE</h2>
                  <div styleName="exchange-header-abbr">Data/Stock not listed on NSE</div>
                </div>
              )}
            </div>
            <div styleName="view-stock-details">
              <a
                href={`/stock/${stockData.STOCKID}/${stockNameSlug}`}
                styleName="view-stock-details-text"
              >
                View Stock Details
              </a>
              <ArrowRightSmall color="sixth-color" height="10" fontSize="10px" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
StockSearch.propTypes = {
  stock: PropTypes.object,
  stockId: PropTypes.string,
  stockValues: PropTypes.object,
  currentIndex: PropTypes.number,
  totalCount: PropTypes.number
};
export default StockSearch;
